import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { d as defineCustomElement$i } from './p-BbTg3Car.js';
import { d as defineCustomElement$h } from './p-7jxIfyyn.js';
import { d as defineCustomElement$g } from './p-CE-SFMeF.js';
import { d as defineCustomElement$f } from './p-BLpMhFGJ.js';
import { d as defineCustomElement$e } from './p-D8nHUWKw.js';
import { d as defineCustomElement$d } from './p-DJoZV0_6.js';
import { d as defineCustomElement$c } from './p-BZccBFnt.js';
import { d as defineCustomElement$b } from './p-Bgz_ZI5S.js';
import { d as defineCustomElement$a } from './p-Da2lAZSv.js';
import { d as defineCustomElement$9 } from './p-PXnlnivq.js';
import { d as defineCustomElement$8 } from './p-CEvUoLql.js';
import { d as defineCustomElement$7 } from './p-B5UnDr4i.js';
import { d as defineCustomElement$6 } from './p-FpOQMZxV.js';
import { d as defineCustomElement$5 } from './p-CtbK9Pbz.js';
import { d as defineCustomElement$4 } from './p-BTthuVdY.js';
import { d as defineCustomElement$3 } from './p-cR96ip-k.js';
import { d as defineCustomElement$2 } from './p-Bn01tsA6.js';

const thumbnailGridCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.content{display:flex;flex-wrap:wrap;gap:1rem;height:100%;overflow-y:auto;width:100%}.content .header{position:sticky;top:0;width:100%;z-index:7}.content .header .header-wrapper{align-content:center;display:flex;justify-content:space-between;min-height:2rem;width:100%}.state-empty,.state-error,.state-loading{align-items:center;background-color:var(--jw-theme-surface-level1-default-bg-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;justify-content:center;letter-spacing:-.0004em;line-height:1.25rem;min-height:15rem}.state-error{color:var(--jw-theme-form-validation-error-color);gap:.25rem}:host([scroll-size=sm][size=sm]) .content{max-height:7rem}:host([scroll-size=sm][size=md]) .content{max-height:10rem}:host([scroll-size=sm][size=lg]) .content{max-height:19rem}:host([scroll-size=sm][size=xl]) .content{max-height:21rem}:host([scroll-size=md][size=sm]) .content{max-height:11rem}:host([scroll-size=md][size=md]) .content{max-height:15.5rem}:host([scroll-size=md][size=lg]) .content{max-height:29rem}:host([scroll-size=md][size=xl]) .content{max-height:32rem}:host([scroll-size=lg][size=sm]) .content{max-height:15rem}:host([scroll-size=lg][size=md]) .content{max-height:21rem}:host([scroll-size=lg][size=lg]) .content{max-height:39rem}:host([scroll-size=lg][size=xl]) .content{max-height:43rem}";

const defaultEmptyState = {
    icon: 'empty',
    heading: 'No images have been added',
    description: 'Added images will appear here.',
};
const WuiThumbnailGrid$1 = /*@__PURE__*/ proxyCustomElement(class WuiThumbnailGrid extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.delete = createEvent(this, "delete", 3);
        this.edit = createEvent(this, "edit", 3);
        /**
         * List of thumbnail items
         */
        this.thumbnails = [];
        /**
         * If a bulk-actions bar should be shown
         */
        this.bulkSelect = false;
        /**
         * Size of each thumbnails in the grid
         */
        this.size = 'lg';
        /**
         * Blur background for thumbnail
         */
        this.blurImage = true;
        this.handleCheckAllInput = (e) => {
            e.stopPropagation();
            if (this.areAllOptionsChecked()) {
                this.setValue([]);
            }
            else {
                this.setValue(this.thumbnails?.map((el) => el.id));
            }
        };
        this.handleInput = (e, id) => {
            e.stopPropagation();
            const target = e.target;
            const { checked } = target;
            if (this.disabled) {
                e.preventDefault();
                return;
            }
            if (checked) {
                this.setValue([...(this.value || []), id]);
            }
            else {
                this.setValue(this.value?.filter((i) => i !== id));
            }
        };
        this.handleEdit = (evt, id) => {
            evt.stopPropagation();
            if (this.disabled || !id) {
                evt.preventDefault();
                return;
            }
            this.edit.emit(id);
        };
        this.handleDelete = (evt, id) => {
            evt.stopPropagation();
            if (this.disabled || !id) {
                evt.preventDefault();
                return;
            }
            this.delete.emit([id]);
        };
        this.handleBulkDelete = (e) => {
            e.stopPropagation();
            this.delete.emit(this.value);
        };
        this.isChecked = (id) => {
            return Boolean(this.value?.includes(id));
        };
        this.areSomeOptionsChecked = () => {
            return (typeof this.thumbnails !== 'undefined' &&
                typeof this.value !== 'undefined' &&
                this.value.length > 0 &&
                this.value.length !== this.thumbnails.length);
        };
        this.areAllOptionsChecked = () => {
            return (typeof this.thumbnails !== 'undefined' &&
                typeof this.value !== 'undefined' &&
                this.value.length === this.thumbnails.length);
        };
        this.isEmpty = () => {
            return Boolean(!this.error && !this.loading && !this.thumbnails?.length);
        };
        this.showThumbnails = () => {
            return Boolean(!this.error && !this.loading && this.thumbnails?.length);
        };
    }
    setValue(value) {
        this.value = value;
        this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
    }
    render() {
        return (h(Host, { key: '72b5f2921b9eeae1f0edd56b721691017bc9b25d' }, this.loading && (h("div", { key: '43b5f016db4c9350c3e18555f90d958a8014342b', class: "state-loading" }, h("wui-loader", { key: 'b23a206e31619bbe32db0069fc9f4b77a2411257', size: "lg" }))), !this.loading && this.error && (h("div", { key: 'cd79700547aea8a7871a719bf27c3eaaf5bfce67', class: "state-error" }, h("wui-icon", { key: 'c01a26477b26404826daba1dc076b389da08317f', name: "alert-circle", size: "xl" }), this.error.message)), !this.loading && !this.error && this.isEmpty() && (h("wui-empty-state", { key: '21d62feab4ea9d90301e204d8d74f0641b6e387b', contents: this.emptyStateContent ? this.emptyStateContent : defaultEmptyState })), this.showThumbnails() && (h("div", { key: 'ae4a3426cacbde1c2f7ac9f76a68ef6db088a5cb', class: "content" }, this.bulkSelect && (h("wui-component-header", { key: 'c693e6563fa4a5c0e7ace975cca4b86fe0bbe591', class: "header" }, h("div", { key: 'f1b170b61a7d4d96e2084dce017c026a9732bb9a', class: "header-wrapper" }, h("wui-check-input", { key: '93508a15c38e587b9156376601b152239343ac23', checked: this.areAllOptionsChecked(), disabled: this.disabled, onInput: this.handleCheckAllInput, label: this.areAllOptionsChecked() ? `${this.value?.length || 0} selected` : 'Select all', indeterminate: this.areSomeOptionsChecked() }), (this.areSomeOptionsChecked() || this.areAllOptionsChecked()) && (h("wui-button", { key: '5668fa16bbf794ca3b8e34062e2261da3c673951', label: "Delete", intent: "error", icon: "trash", type: "tertiary", onClick: this.handleBulkDelete }))))), this.thumbnails?.map(({ id, label, badge, src, ...rest }) => (h("wui-thumbnail", { key: id, label: label, badge: badge, src: src, blurImage: this.blurImage, size: this.size, checked: this.isChecked(id), checkable: !this.disabled && this.bulkSelect, disabled: this.disabled, onInput: (e) => this.handleInput(e, id), hoverActions: [
                {
                    type: 'tertiary',
                    label: 'Edit',
                    icon: 'pencil',
                    onClick: (e) => this.handleEdit(e, id),
                },
                {
                    type: 'tertiary',
                    label: 'Delete',
                    icon: 'trash',
                    onClick: (e) => this.handleDelete(e, id),
                },
            ], ...rest })))))));
    }
    get elm() { return this; }
    static get style() { return thumbnailGridCss; }
}, [257, "wui-thumbnail-grid", {
        "thumbnails": [16],
        "bulkSelect": [4, "bulk-select"],
        "size": [513],
        "blurImage": [4, "blur-image"],
        "error": [16],
        "value": [1040],
        "loading": [4],
        "disabled": [4],
        "scrollSize": [513, "scroll-size"],
        "emptyStateContent": [16, "empty-state-content"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-thumbnail-grid", "wui-box", "wui-button", "wui-check-input", "wui-close-button", "wui-component-header", "wui-empty-state", "wui-form-field", "wui-graph-icon", "wui-icon", "wui-layout", "wui-loader", "wui-logo", "wui-status", "wui-tag", "wui-thumbnail", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-thumbnail-grid":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiThumbnailGrid$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-component-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-empty-state":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-graph-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-logo":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-thumbnail":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiThumbnailGrid = WuiThumbnailGrid$1;
const defineCustomElement = defineCustomElement$1;

export { WuiThumbnailGrid, defineCustomElement };
